import parsePhoneNumberFromString from "libphonenumber-js";
export const validateEmailAddress = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};
export const maskEmail = (email, length) => {
  if (!email) return "";
  // Split the email address into local part and domain
  const [localPart, domain] = email.split("@");

  // Get the length of the local part
  const localPartLength = localPart.length;

  // Mask the email address
  const maskedEmail =
    localPartLength > 2
      ? `${localPart.substring(0, 2)}${"•".repeat(
          localPartLength - 2 > 10 ? 10 : localPartLength - 2,
        )}@${domain}`
      : `${localPart.substring(0, 2)}${"•".repeat(3)}@${domain}`;

  if (length) return maskedEmail.substring(0, length + 5) + "...";
  if (maskedEmail.length > 15) return maskedEmail.substring(0, 6) + domain;
  return maskedEmail;
};

export const getFormatedDate = (inputDateString, monthType = "short") => {
  const inputDate = new Date(inputDateString);

  const formattedDateTime = {
    date: inputDate.toLocaleDateString("en-US", {
      month: monthType,
      day: "2-digit",
      year: "numeric",
    }),
    time: inputDate.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }),
  };
  return formattedDateTime;
};

// export const formatPhoneNumber = (phoneNumber, countryCode) => {
//   const parsedNumber = parsePhoneNumberFromString(phoneNumber, countryCode);

//   if (parsedNumber) {
//     // Format the number according to the country-specific format
//     return parsedNumber.formatInternational();
//   } else {
//     // Return the original number if parsing fails
//     return phoneNumber;
//   }
// };
export const formatPhoneNumber = (phoneNumber, countryCode) => {
  const numericPhoneNumber = phoneNumber.replace(/\D/g, "");
  if (phoneNumber.length > 0) {
    switch (countryCode) {
      case "US":
        return `+1 (${numericPhoneNumber.slice(
          1,
          4,
        )}) ${numericPhoneNumber.slice(4, 7)}-${numericPhoneNumber.slice(7)}`;
      case "PK":
        return `+92 ${numericPhoneNumber.slice(
          2,
          5,
        )} ${numericPhoneNumber.slice(5)}`;
      case "GB":
        return `+44 (0) ${numericPhoneNumber.slice(
          1,
          6,
        )} ${numericPhoneNumber.slice(6)}`;
      case "AU":
        return `0${numericPhoneNumber.slice(1, 4)} ${numericPhoneNumber.slice(
          4,
        )}`;
      case "IN":
        return `+91 ${numericPhoneNumber.slice(
          1,
          6,
        )}-${numericPhoneNumber.slice(6)}`;
      case "CA":
        return `+1 (${numericPhoneNumber.slice(
          1,
          4,
        )}) ${numericPhoneNumber.slice(4, 7)}-${numericPhoneNumber.slice(7)}`;
      case "DE":
        return `+49 (0) ${numericPhoneNumber.slice(
          1,
          5,
        )} ${numericPhoneNumber.slice(5, 9)}-${numericPhoneNumber.slice(9)}`;
      case "JP":
        return `0${numericPhoneNumber.slice(1, 3)}-${numericPhoneNumber.slice(
          3,
          7,
        )}-${numericPhoneNumber.slice(7)}`;
      default:
        return phoneNumber;
    }
  } else {
    return phoneNumber;
  }
};

// // Example usage
// const phoneNumber = "+1234567890";
// const countryCode = "US"; // Country code for the United States
// const formattedPhoneNumber = formatPhoneNumber(phoneNumber, countryCode);

export const toTitleCase = (text) => {
  if (!text) return "";
  return text
    .toLowerCase()
    .split(" ")
    .map(function (word) {
      return word.charAt(0)?.toUpperCase() + word.slice(1);
    })
    .join(" ")
    .split("-")
    .map(function (word) {
      return word.charAt(0)?.toUpperCase() + word.slice(1);
    })
    .join("-");
};

export const phoneNumberFormat = (phoneNumber) => {
  if (!phoneNumber.length) return "";
  // Remove all white spaces, parentheses, and dashes
  const cleanedNumber = phoneNumber.replace(/[\s()+-]/g, "");

  // Format the phone number
  const countryCode = cleanedNumber.substring(0, cleanedNumber.length - 10);
  const areaCode = cleanedNumber.substring(
    cleanedNumber.length - 10,
    cleanedNumber.length - 7,
  );
  const firstThree = cleanedNumber.substring(
    cleanedNumber.length - 7,
    cleanedNumber.length - 4,
  );
  const lastFour = cleanedNumber.substring(cleanedNumber.length - 4);

  return `+${countryCode} (${areaCode}) ${firstThree}-${lastFour}`;
};

export const getBadgeVariant = (input) => {
  switch (input) {
    case "Draft":
      return "gray";
    case "New Request":
      return "primary";
    case "New":
      return "primary";
    case "Signed Off":
      return "warning";
    case "Cancelled":
      return "danger";
    case "Completed":
      return "success";
    case 1:
      return "gray";
    case 2:
      return "primary";
    case 3:
      return "primary";
    case 4:
      return "warning";
    case 5:
      return "danger";
    case 6:
      return "success";
    default:
      return "blue";
  }
};

export const getFormattedDate = (isoString) => {
  const date = new Date(isoString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.?([a-zA-Z]{2})$/;
const aplhaRegex = /^(?=.*[a-zA-Z]).+$/;
// export const emailAdressValidator = (email) =>
//   aplhaRegex.test(email.split("@")[0]) && emailRegex.test(email);
export const emailAdressValidator = (email) => {
    if (!email.includes("@")) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  
export const isValidUrl = (url) => {
  const regex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/g;

  return regex.test(url) ?? false;
};
